<div class="p-4 md:p-6 max-w-3xl mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">settings</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">Modificar parámetros para tasa fiat</h1>
  </div>

  <!-- Candado de edición (solo producción). Ver AdminEditPermissionsService -->
  <app-solo-lectura-banner *ngIf="!puedeEditar"
    detalle="La edición de los parámetros de tasa fiat está reservada al operador autorizado.">
  </app-solo-lectura-banner>

  <!-- Card Formulario -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">tune</mat-icon>
        Parámetros
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="ratesFiatForm">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Setup</mat-label>
            <input matInput formControlName="setup" appOnlynumber matInputCommified type="text" placeholder="Setup">
            <span matTextPrefix>Bs&nbsp;</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Valor Solvencia (ValorSL)</mat-label>
            <input matInput formControlName="valorSolvenciaFiat" appOnlynumber matInputCommified type="text" placeholder="Valor SL">
            <span matTextPrefix>Bs&nbsp;</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Valor Solvencia Máxima (ValorSL)</mat-label>
            <input matInput formControlName="valorSolvenciaMaximaFiat" appOnlynumber matInputCommified type="text" placeholder="Valor SL">
            <span matTextPrefix>Bs&nbsp;</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field">
            <mat-label>Valor Liquidez (ValorLQ)</mat-label>
            <input matInput formControlName="valorLiquidezFiat" appOnlynumber matInputCommified type="text" placeholder="Valor LQ">
            <span matTextPrefix>USDT&nbsp;</span>
          </mat-form-field>

          <mat-form-field appearance="outline" class="modern-field sm:col-span-2" style="max-width: 50%;">
            <mat-label>Valor Descuento (Bs)</mat-label>
            <input matInput formControlName="valorDescuentoFiat" appOnlynumber matInputCommified type="text" placeholder="Valor descuento">
            <span matTextPrefix>Bs&nbsp;</span>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="showConfirm()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; width: 100%;"
            class="sm:w-auto"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
            Actualizar
          </button>
          <button type="button" [disabled]="!puedeEditar"
            [style.opacity]="puedeEditar ? '1' : '0.5'"
            [style.cursor]="puedeEditar ? 'pointer' : 'not-allowed'" (click)="reset()"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 10px 28px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.9rem; cursor: pointer; transition: all 0.2s ease; width: 100%;"
            class="sm:w-auto"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">restart_alt</mat-icon>
            Restablecer
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Cómo se calcula la tasa (informativo, no editable) -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">functions</mat-icon>
        Cómo se calcula la tasa
      </h2>
      <button type="button" (click)="mostrarFormula = !mostrarFormula"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">{{ mostrarFormula ? 'expand_less' : 'expand_more' }}</mat-icon>
        {{ mostrarFormula ? 'Ocultar detalle' : 'Ver detalle' }}
      </button>
    </div>

    <div class="p-5">
      <!-- Fórmula resumida: siempre visible -->
      <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-left: 4px solid #1C593D; border-radius: 10px; padding: 16px;">
        <p style="margin: 0 0 10px; font-size: 0.8rem; font-weight: 700; color: #64748b; letter-spacing: 0.03em;">
          TASA FINAL (Bs por 1 CLP)
        </p>
        <div style="font-family: ui-monospace, 'Cascadia Code', Consolas, monospace; font-size: 0.9rem; line-height: 1.9; color: #0f172a; overflow-x: auto;">
          <span style="color:#1C593D; font-weight:700;">Tasa</span>
          =
          ( <span style="color:#b45309;">Precio Binance</span>
          &minus; <span style="color:#b45309;">Descuento</span> )
          &divide; <span style="color:#0369a1;">Tasa CLP/USDT</span>
          &times; ( 1 &minus; <span style="color:#0369a1;">Comisión</span> / 100 )
        </div>
        <p style="margin: 10px 0 0; font-size: 0.78rem; color: #64748b;">
          En <span style="color:#b45309; font-weight:600;">naranja</span> lo que se configura en esta pantalla.
          En <span style="color:#0369a1; font-weight:600;">azul</span> lo que viene de la tasa de cambio vigente (panel de abajo).
        </p>
      </div>

      <!-- Detalle desplegable -->
      <div *ngIf="mostrarFormula" class="mt-5">

        <!-- Paso 1 -->
        <div class="mb-5">
          <h3 style="margin: 0 0 8px; font-size: 0.9rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
            <span style="display:inline-flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#1C593D; color:white; font-size:0.75rem; font-weight:700;">1</span>
            Se elige la oferta en Binance P2P
          </h3>
          <p style="margin: 0 0 10px; font-size: 0.85rem; color: #475569; line-height: 1.6;">
            Cada minuto el sistema consulta Binance P2P (vender USDT por Bs, sólo comerciantes verificados)
            para Banesco, Provincial, Mercantil y Venezuela. De cada banco descarta los anuncios promocionados
            y se queda con la primera oferta que cumpla <b>todos</b> estos filtros:
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
            <div style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:12px;">
              <p style="margin:0; font-size:0.72rem; font-weight:700; color:#92400e; letter-spacing:0.03em;">SETUP</p>
              <p style="margin:4px 0 0; font-family: ui-monospace, Consolas, monospace; font-size:1rem; font-weight:700; color:#0f172a;">
                {{ setup | number:'1.0-2' }} Bs
              </p>
              <p style="margin:6px 0 0; font-size:0.78rem; color:#78716c; line-height:1.5;">
                Es el monto que se le dice a Binance que se quiere operar. Cambia qué anuncios devuelve la búsqueda.
              </p>
            </div>
            <div style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:12px;">
              <p style="margin:0; font-size:0.72rem; font-weight:700; color:#92400e; letter-spacing:0.03em;">LIQUIDEZ</p>
              <p style="margin:4px 0 0; font-family: ui-monospace, Consolas, monospace; font-size:1rem; font-weight:700; color:#0f172a;">
                {{ valorLiquidezFiat | number:'1.0-2' }} USDT
              </p>
              <p style="margin:6px 0 0; font-size:0.78rem; color:#78716c; line-height:1.5;">
                El anuncio debe tener al menos este saldo disponible. Sube el valor para descartar comerciantes chicos.
              </p>
            </div>
            <div style="background:#fffbeb; border:1px solid #fde68a; border-radius:10px; padding:12px;">
              <p style="margin:0; font-size:0.72rem; font-weight:700; color:#92400e; letter-spacing:0.03em;">SOLVENCIA MÁXIMA</p>
              <p style="margin:4px 0 0; font-family: ui-monospace, Consolas, monospace; font-size:1rem; font-weight:700; color:#0f172a;">
                {{ valorSolvenciaMaximaFiat | number:'1.0-2' }} Bs
              </p>
              <p style="margin:6px 0 0; font-size:0.78rem; color:#78716c; line-height:1.5;">
                El tope por operación del anuncio debe llegar al menos a este monto, para que cubra las remesas grandes.
              </p>
            </div>
          </div>
          <div style="margin-top:12px; background:#f1f5f9; border:1px solid #e2e8f0; border-radius:10px; padding:12px;">
            <p style="margin:0; font-size:0.8rem; color:#475569; line-height:1.6;">
              <b>Además, control de precio estable:</b> se necesitan al menos 3 anuncios que pasen los filtros, y el
              elegido sólo se toma si el 2&deg; está a menos de <b>0,2%</b> y el 3&deg; a menos de <b>0,5%</b> de su
              precio. Si no, se descarta y se prueba con el siguiente. Esto evita tomar un precio aislado fuera de mercado.
            </p>
          </div>
        </div>

        <!-- Paso 2 -->
        <div class="mb-5">
          <h3 style="margin: 0 0 8px; font-size: 0.9rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
            <span style="display:inline-flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#1C593D; color:white; font-size:0.75rem; font-weight:700;">2</span>
            Se le resta el descuento
          </h3>
          <p style="margin: 0; font-size: 0.85rem; color: #475569; line-height: 1.6;">
            Al precio del anuncio se le restan
            <b style="color:#b45309;">{{ valorDescuentoFiat | number:'1.0-4' }} Bs</b>
            (parámetro <b>Valor Descuento</b>). Es el margen sobre el precio de mercado: subirlo baja la tasa que
            recibe el cliente, bajarlo la sube.
          </p>
        </div>

        <!-- Paso 3 -->
        <div class="mb-5">
          <h3 style="margin: 0 0 8px; font-size: 0.9rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
            <span style="display:inline-flex; align-items:center; justify-content:center; width:22px; height:22px; border-radius:50%; background:#1C593D; color:white; font-size:0.75rem; font-weight:700;">3</span>
            Se pasa de Bs/USDT a Bs/CLP y se aplica la comisión
          </h3>
          <p style="margin: 0; font-size: 0.85rem; color: #475569; line-height: 1.6;">
            El precio de Binance está en <b>Bs por USDT</b>. Se divide por la <b>Tasa CLP/USDT</b> vigente para
            pasarlo a <b>Bs por CLP</b>, y sobre eso se descuenta el <b>% de comisión</b>. Estos dos valores no se
            editan acá: salen de la tasa de cambio vigente que se ve en el panel de abajo.
          </p>
        </div>

        <!-- Ejemplo con valores reales -->
        <div *ngIf="ejemplo as e" style="background:#f0fdf4; border:1px solid #bbf7d0; border-radius:12px; padding:16px;">
          <p style="margin:0 0 12px; font-size:0.85rem; font-weight:700; color:#1e5a3f; display:flex; align-items:center; gap:6px;">
            <mat-icon style="font-size:18px; width:18px; height:18px; color:#1C593D;">calculate</mat-icon>
            Ejemplo con los valores de ahora (Banesco)
          </p>
          <div style="font-family: ui-monospace, 'Cascadia Code', Consolas, monospace; font-size:0.82rem; line-height:2; color:#0f172a; overflow-x:auto; white-space:nowrap;">
            <div>Precio Binance&nbsp; = <b>{{ e.precioBruto | number:'1.2-4' }}</b> Bs/USDT</div>
            <div>&minus; Descuento&nbsp;&nbsp;&nbsp;&nbsp; = {{ e.descuento | number:'1.2-4' }} &nbsp;&rarr;&nbsp; <b>{{ e.precioNeto | number:'1.2-4' }}</b> Bs/USDT</div>
            <div>&divide; Tasa CLP/USDT = {{ e.tasaCLP | number:'1.2-2' }} &nbsp;&rarr;&nbsp; <b>{{ e.base | number:'1.5-6' }}</b> Bs/CLP</div>
            <div>&times; (1 &minus; {{ e.comision | number:'1.0-2' }}%)&nbsp;&nbsp; &rarr;&nbsp; <b style="color:#1C593D;">{{ e.tasaFinal | number:'1.5-6' }}</b> Bs/CLP</div>
          </div>
          <p style="margin:12px 0 0; padding-top:12px; border-top:1px dashed #86efac; font-size:0.82rem; color:#475569;">
            Es decir, <b>{{ 100000 | number:'1.0-0' }} CLP = {{ e.tasaFinal * 100000 | number:'1.0-2' }} Bs</b>.
            <span *ngIf="e.tasaVigente"> Tasa Banesco vigente publicada: <b>{{ e.tasaVigente | number:'1.5-6' }}</b>.</span>
          </p>
        </div>
        <div *ngIf="!ejemplo" style="background:#f8fafc; border:1px dashed #cbd5e1; border-radius:12px; padding:16px; font-size:0.82rem; color:#64748b;">
          El ejemplo aparece cuando termine de cargar la tasa de cambio vigente.
        </div>

        <!-- Nota: parámetro sin efecto -->
        <div style="margin-top:16px; background:#fef2f2; border:1px solid #fecaca; border-radius:10px; padding:12px; display:flex; gap:10px;">
          <mat-icon style="font-size:18px; width:18px; height:18px; color:#b91c1c; flex-shrink:0; margin-top:2px;">info</mat-icon>
          <p style="margin:0; font-size:0.8rem; color:#7f1d1d; line-height:1.6;">
            <b>Valor Solvencia (ValorSL)</b> hoy no interviene en el cálculo: el filtro que lo usaba está
            desactivado en el backend. Se guarda igual, pero cambiarlo no altera la tasa.
          </p>
        </div>

        <!-- Cuándo se recalcula -->
        <div style="margin-top:12px; font-size:0.78rem; color:#64748b; display:flex; align-items:center; gap:6px;">
          <mat-icon style="font-size:16px; width:16px; height:16px; color:#94a3b8;">schedule</mat-icon>
          El cálculo automático corre cada minuto, y sólo si la actualización de tasas VES está en modo AUTOMÁTICO.
        </div>
      </div>
    </div>
  </div>

  <!-- Binance Rate -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">show_chart</mat-icon>
        Tasa Binance
      </h2>
      <button type="button" (click)="reloadData()"
        style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">refresh</mat-icon>
        Refrescar
      </button>
    </div>
    <div class="p-5">
      <app-binance-rate [showCopyToClipboard]="true" class="w-full"></app-binance-rate>
    </div>
  </div>
</div>
